import { appUrl } from "../../constants/url-constants";

export const REDIRECT_URLS = {
    SELL_MY_CAR: "sell-my-car"
};

export const redirectToUrl = ({absoluteURL = appUrl(), relativeURL = ""} = {}) => {
    if (relativeURL) {
        const base = appUrl().replace(/\/+$/, "");
        const path = String(relativeURL).replace(/^\/+/, "");
        window.location.href = `${base}/${path}`;
        return;
    }
    window.location.href = absoluteURL;
};
